const capitalize = (text: string): string => {
  return text
    .toLowerCase()
    .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase())
}

export default capitalize
